import React from 'react'

const MedicoContext = React.createContext({ 
        estado: '',
        precisaAtualizar: false,
        atualizarGrade: () => {},
        blockingPanel: false,
        setVisibleBlockingPanel: () => {},
        data: {}, 
        setData: () => {} })

export const MedicoProvider = MedicoContext.Provider

export { MedicoContext }
